class ACError extends Error {
  static ACERROR_DOUBLE_INITIALIZATION = 1;

  static ACERROR_BITMAP_MISSING = 2;

  static ACERROR_AUTHORIZATION_MISSING = 4;

  static ACERROR_UNDEFINED_PERMISSIONS = 8;

  constructor(msg, errCode) {
    super(msg)
    this.name = 'ACError'

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor)
    }

    Object.keys(ACError).forEach((key) => {
      if (key.indexOf('ACERROR_') === 0 && ACError[key] === errCode) {
        msg = `${key}: ${msg}`
      }
    })

    this.message = msg
    this.errCode = errCode
  }
}

class DefaultFailureInstance {

  isAuthorized() {
    return false
  }

  assertAuthorized() {
    throw new ACError(
      'Authorization missing',
      ACError.ACERROR_AUTHORIZATION_MISSING
    )
  }

  setPermissions() {
    return false
  }
}

let privateInstance = new DefaultFailureInstance()

function getInstance() {

  if (privateInstance instanceof DefaultFailureInstance) {
    console.info('You need to initialize the ACL first. '
      + 'Call AccessControllService.init(userPermissions)')
  }

  return privateInstance

}

function setInstance(instance) {
  privateInstance = instance
}

function parsePermission(permission) {

  if (permission === undefined) {
    throw new ACError(
      'Permission needs to be defined!',
      ACError.ACERROR_UNDEFINED_PERMISSIONS
    )
  }

  return permission.toUpperCase().split(',')

}
function assertIsValidPermissionDefinition(userPermissions, key) {
  if (!(userPermissions[key])) {
    throw new ACError(
      'A bitmap defining permissions is missing!',
      ACError.ACERROR_BITMAP_MISSING
    )
  }
}

function addPermission(permissions, userPermissions, key) {
  permissions[key] = userPermissions[key] || 0
}

class AccessControllService {
  constructor(userPermissions) {

    if (userPermissions === undefined) {
      throw new ACError(
        'The AccessControlService needs to be initialized with permissions!',
        ACError.ACERROR_UNDEFINED_PERMISSIONS
      )
    }

    this.permissions = {}

    this.setPermissions(userPermissions)

  }

  setPermissions(userPermissions) {
    this.permissions = {}
    Object.keys(userPermissions).forEach((key) => {
      assertIsValidPermissionDefinition(userPermissions, key)
      addPermission(this.permissions, userPermissions, key)
    })
  }

  isAuthorized(permissionString) {

    const permissions = parsePermission(permissionString)
    let retval = this.permissions[permissions[0]]
    let i = 1
    const len = permissions.length

    for (i = 1; i < len && retval; i += 1) {
      retval = this.permissions[permissions[i]]
    }

    return !!retval

  }

  assertAuthorized(permissionString) {

    if (this.isAuthorized[permissionString]) {
      return true
    }

    throw new ACError(
      `Authorization missing for "${permissionString}"`,
      ACError.ACERROR_AUTHORIZATION_MISSING
    )

  }
}

export default {

  isAuthorized(permission) {

    return getInstance().isAuthorized(permission)

  },

  assertAuthorized(permission) {

    const permissions = parsePermission(permission)
    let retval = getInstance().assertAuthorized(permissions[0])
    let i = 1
    const len = permissions.length

    for (i = 1; i < len && retval; i += 1) {
      retval = getInstance().assertAuthorized(permissions[i])
    }

    return retval

  },

  init(userPermissions) {

    const instance = getInstance()

    if (!(instance instanceof DefaultFailureInstance)) {

      instance.setPermissions(userPermissions)

    }
    else {

      setInstance(this.create(userPermissions))

    }

  },

  create(userPermissions) {

    return new AccessControllService(userPermissions)

  },

  setPermissions(permissions) {

    return getInstance().setPermissions(permissions)

  },

  ACError,
}



// WEBPACK FOOTER //
// ./src/auth/acservice.js